<div class="form-view-receipt"  id="{{ 'receipt' + fieldKey }}" (click)="getReceipt(field.templateOptions.options[0].type)">
    <div class="view-receipt" id="viewReceipt" [ngClass]="field.templateOptions.options[0].className">
        <img class="icons" [src]="ICONS.FILE_TEXT" alt="" />
        <!-- <em class="fal" [ngClass]="field.templateOptions.options[0].iconClass"></em> -->
        @if(field.templateOptions.options[0].receiptCount>0){
            <span class="badge-pill">
                {{field.templateOptions.options[0].receiptCount}}
            </span>
        }
    </div>
    <p class="view-receipt-text">{{field.templateOptions.options[0].label}}</p>
</div>